import { queryOptions } from '@tanstack/react-query';

import {
  fetchCompetitionSeasonStats,
  fetchHeadToHead,
  fetchMatchStats,
  fetchPlayerStats,
  fetchSinglePlayerStats,
  fetchStatsDefinitions,
} from '@apis/statistics';

export const getMatchStatsQuery = (matchId: string, playerId?: string) =>
  queryOptions({
    queryKey: ['match-stats', matchId, playerId],
    queryFn: ({ signal }) => fetchMatchStats(matchId, playerId, signal),
    select: (response) => response?.at(0),
    enabled: !!matchId && !!playerId,
  });

export const getHeadToHeadQuery = (params: Parameters<typeof fetchHeadToHead>[0]) =>
  queryOptions({
    queryKey: ['head-to-head', params],
    queryFn: ({ signal }) => fetchHeadToHead(params, signal),
  });

export const getStatDefinitionsQuery = () =>
  queryOptions({
    queryKey: ['stat-definitions'],
    queryFn: ({ signal }) => fetchStatsDefinitions(signal),
  });

export const getPlayersStatsQuery = (params: Parameters<typeof fetchPlayerStats>[0]) =>
  queryOptions({
    queryKey: ['player-stats', params],
    queryFn: ({ signal }) => fetchPlayerStats(params, signal),
  });

export const getSinglePlayerStatsQuery = (params: Parameters<typeof fetchSinglePlayerStats>[0]) =>
  queryOptions({
    queryKey: ['player-stats', params],
    queryFn: ({ signal }) => fetchSinglePlayerStats(params, signal),
  });

export const getCompetitionSeasonStatsQuery = (params: Parameters<typeof fetchCompetitionSeasonStats>[0]) =>
  queryOptions({
    queryKey: ['player-statistics/all-time', params],
    queryFn: ({ signal }) => fetchCompetitionSeasonStats(params, signal),
    placeholderData: [],
  });
